import React, { useContext } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import { MdCall } from "react-icons/md";
import { mouseContext } from "../../context/mouseContext";
import classes from "./Footer.module.css";
import FooterCard from "./FooterCard";

// 🔹 add your logo here
import IQ from '../../assets/img/iqapex-logo.png';

const Footer = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(mouseContext);

  const expertiseArr = [
    ["Product Engineering", "product-engineering"],
    ["Expertise Solutions", "expertise-solutions"],
    ["Talent Partnership", "talent-partnership"],
  ];

  const usefulArr = [
    ["Careers", "careers"],
    ["Announcements", "announcements"],
    ["Partner with us", "partner"],
  ];

  const industries = [
    ["Information Technology", "it"],
    ["E-commerce & Retail", "ecommerce"],
    ["AR/VR in Manufacturing", "ar-vr"],
    ["Travel & Logistics", "travel"],
    ["Sustainability & Climate Change", "sustainability"],
  ];

  const addresses = [
    "Shyamnagar, Kolkata, West Bengal, India",
    "New Town, Rajarhat , North 24 Parganas, West Bengal, India, 700102",
    "Jayanagar, Karnataka, India, 560011",
    "Hi-Tech City, Telengana, IN,500081",
    "Pusa Campus, Todapur, Delhi-110012",
    "Borjhar, Guwahati near Airport, India, 781015",
  ];

  return (
    <footer className={classes.footer}>
      <div className={classes.footerInner}>
        {/* ===== Brand Section ===== */}
        <div className={classes.brand}>
          <img src={IQ} alt="IQApex Labs Logo" className={classes.logo} />
          <p className={classes.tagline}>
            Engineering innovation, building digital excellence, and enabling
            businesses to scale with confidence.
          </p>

          <div className={classes.social}>
            <a
              href="https://www.facebook.com/IQApexLabs"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/iqapexlabs"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/iqapex-labs/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              onMouseEnter={mouseEnterHandler}
              onMouseLeave={mouseLeaveHandler}
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        {/* ===== Links Section ===== */}
        <div className={classes.links}>
          <FooterCard title="Our Expertise" links={expertiseArr} />
          <FooterCard title="Useful Links" links={usefulArr} />
          <FooterCard title="Industries" links={industries} />
        </div>

        {/* ===== Contact Section ===== */}
        <div className={classes.contact}>
          <h3>Get in Touch</h3>

          {addresses.map((address, index) => (
            <div key={index} className={classes.contactItem}>
              <span className={classes.iconCircle}>
                <FaMapMarkerAlt />
              </span>
              <p>{address}</p>
            </div>
          ))}

          <div className={classes.contactItem}>
            <span className={classes.iconCircle}>
              <GrMail />
            </span>
            <p>
              <a href="mailto:contact@iqapexlabs.com">
                contact@iqapexlabs.com
              </a>
            </p>
          </div>

          <div className={classes.contactItem}>
            <span className={classes.iconCircle}>
              <MdCall />
            </span>
            <p>
              <a href="tel:+916289569385">+91 62895 69385</a>
            </p>
          </div>
        </div>
      </div>

      {/* ===== Bottom Bar ===== */}
      <div className={classes.bottom}>
        © 2024 IQApex Labs. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
